import {useTranslation} from "react-i18next";
import {css, useTheme} from "@emotion/react";
import {Button} from "@pg-design/button";
import {calculateRemSize, flex, flexAlignCenter, mb, onDesktop, p, pl, underline, w100} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link";
import {Text} from "@pg-design/text";

import {flexGap} from "../../../components/css_helpers/flex";

interface IPrice {
    price: string;
    primaryButton?: {
        text: string;
        href: string;
    };
    secondaryButton?: {
        text: string;
        href: string;
    };
}

export const Price = ({price, primaryButton, secondaryButton}: IPrice) => {
    const {t} = useTranslation();
    const theme = useTheme();

    return (
        <div css={wrapper}>
            <div css={priceText}>
                <Text variant="headline_1" as="span">
                    {price} {t("common.pln")}
                </Text>
                <Text variant="info_txt_1" as="span" css={[pl(1), mb(1)]}>
                    / {t("pricing.month")}
                </Text>
            </div>

            {(primaryButton || secondaryButton) && (
                <div css={buttonsWrapper}>
                    {primaryButton && (
                        <Button css={button} size="small" variant="filled_primary" href={primaryButton.href}>
                            <Text variant="button_small">{primaryButton.text}</Text>
                        </Button>
                    )}
                    {secondaryButton && (
                        <Button css={button} size="small" variant="outlined_secondary" href={secondaryButton.href}>
                            <Text variant="button_small">{secondaryButton.text}</Text>
                        </Button>
                    )}
                </div>
            )}

            <Text color={theme.colors.gray["800"]} variant="info_txt_1" align="center">
                <Link
                    underline
                    css={linkText}
                    size="small"
                    href="https://rynekpierwotny.pl/dla-dewelopera/"
                    target="_blank"
                >
                    {t("pricing.cooperation_1")}
                </Link>
                {t("pricing.cooperation_2")}
            </Text>
        </div>
    );
};

const minHeight = css`
    min-height: 62px;

    ${w100};

    ${onDesktop(css`
        min-height: 228px;
    `)}
`;

const wrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${flexGap(2)};
    ${minHeight};
    ${p(3)};
    ${flexAlignCenter};
`;

const priceText = css`
    ${flex("center", "center")};
`;

const buttonsWrapper = css`
    ${flex("center", "center")};
    ${flexGap(2)}
    flex-wrap: wrap;
`;

const button = css`
    width: ${calculateRemSize(24)};
`;

const linkText = css`
    &:any-link {
        ${underline};
    }

    color: inherit;
`;
